import { render, staticRenderFns } from "./NavbarAdmin.vue?vue&type=template&id=47379df7"
import script from "./NavbarAdmin.vue?vue&type=script&lang=js"
export * from "./NavbarAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports